<a [href]="link">
  <img
    class="image-with-link"
    width="32"
    height="32"
    [src]="imgSrc"
    [alt]="imgAlt || 'logo'" />
</a>
